import { defineComponent as P, ref as a, watch as C, toRef as S, computed as j, inject as A, nextTick as O, provide as g, cloneVNode as E, mergeProps as M, withDirectives as k, h as c, Transition as x, vShow as T } from "vue";
import { dialogPropKeys as q } from "./ghl-ui.es982.js";
import { NDialog as D } from "./ghl-ui.es981.js";
import K, { cardBasePropKeys as I } from "./ghl-ui.es187.js";
import { drawerBodyInjectionKey as V } from "./ghl-ui.es989.js";
import { popoverBodyInjectionKey as X } from "./ghl-ui.es1345.js";
import { modalInjectionKey as Y, modalBodyInjectionKey as _ } from "./ghl-ui.es1053.js";
import { presetProps as H } from "./ghl-ui.es1051.js";
import { useLockHtmlScroll as W } from "./ghl-ui.es1346.js";
import { getFirstSlotVNode as z } from "./ghl-ui.es872.js";
import { warn as G } from "./ghl-ui.es853.js";
import J from "./ghl-ui.es994.js";
import { FocusTrap as Q } from "./ghl-ui.es1222.js";
import U from "./ghl-ui.es718.js";
import { keep as R } from "./ghl-ui.es930.js";
const pe = P({
  name: "ModalBody",
  inheritAttrs: !1,
  props: Object.assign(Object.assign({
    show: {
      type: Boolean,
      required: !0
    },
    preset: String,
    displayDirective: {
      type: String,
      required: !0
    },
    trapFocus: {
      type: Boolean,
      default: !0
    },
    autoFocus: {
      type: Boolean,
      default: !0
    },
    blockScroll: Boolean
  }, H), {
    renderMask: Function,
    // events
    onClickoutside: Function,
    onBeforeLeave: {
      type: Function,
      required: !0
    },
    onAfterLeave: {
      type: Function,
      required: !0
    },
    onPositiveClick: {
      type: Function,
      required: !0
    },
    onNegativeClick: {
      type: Function,
      required: !0
    },
    onClose: {
      type: Function,
      required: !0
    },
    onAfterEnter: Function,
    onEsc: Function
  }),
  setup(t) {
    const s = a(null), n = a(null), l = a(t.show), d = a(null), u = a(null);
    C(S(t, "show"), (e) => {
      e && (l.value = !0);
    }), W(j(() => t.blockScroll && l.value));
    const r = A(Y);
    function i() {
      if (r.transformOriginRef.value === "center")
        return "";
      const {
        value: e
      } = d, {
        value: o
      } = u;
      if (e === null || o === null)
        return "";
      if (n.value) {
        const v = n.value.containerScrollTop;
        return `${e}px ${o + v}px`;
      }
      return "";
    }
    function f(e) {
      if (r.transformOriginRef.value === "center")
        return;
      const o = r.getMousePosition();
      if (!o || !n.value)
        return;
      const v = n.value.containerScrollTop, {
        offsetLeft: $,
        offsetTop: w
      } = e;
      if (o) {
        const N = o.y, L = o.x;
        d.value = -($ - L), u.value = -(w - N - v);
      }
      e.style.transformOrigin = i();
    }
    function m(e) {
      O(() => {
        f(e);
      });
    }
    function p(e) {
      e.style.transformOrigin = i(), t.onBeforeLeave();
    }
    function h() {
      l.value = !1, d.value = null, u.value = null, t.onAfterLeave();
    }
    function b() {
      const {
        onClose: e
      } = t;
      e && e();
    }
    function F() {
      t.onNegativeClick();
    }
    function B() {
      t.onPositiveClick();
    }
    const y = a(null);
    return C(y, (e) => {
      e && O(() => {
        const o = e.el;
        o && s.value !== o && (s.value = o);
      });
    }), g(_, s), g(V, null), g(X, null), {
      mergedTheme: r.mergedThemeRef,
      appear: r.appearRef,
      isMounted: r.isMountedRef,
      mergedClsPrefix: r.mergedClsPrefixRef,
      bodyRef: s,
      scrollbarRef: n,
      displayed: l,
      childNodeRef: y,
      handlePositiveClick: B,
      handleNegativeClick: F,
      handleCloseClick: b,
      handleAfterLeave: h,
      handleBeforeLeave: p,
      handleEnter: m
    };
  },
  render() {
    const {
      $slots: t,
      $attrs: s,
      handleEnter: n,
      handleAfterLeave: l,
      handleBeforeLeave: d,
      preset: u,
      mergedClsPrefix: r
    } = this;
    let i = null;
    if (!u) {
      if (i = z(t), !i) {
        G("modal", "default slot is empty");
        return;
      }
      i = E(i), i.props = M({
        class: `${r}-modal`
      }, s, i.props || {});
    }
    return this.displayDirective === "show" || this.displayed || this.show ? k(c("div", {
      role: "none",
      class: `${r}-modal-body-wrapper`
    }, c(J, {
      ref: "scrollbarRef",
      theme: this.mergedTheme.peers.Scrollbar,
      themeOverrides: this.mergedTheme.peerOverrides.Scrollbar,
      contentClass: `${r}-modal-scroll-content`
    }, {
      default: () => {
        var f;
        return [(f = this.renderMask) === null || f === void 0 ? void 0 : f.call(this), c(Q, {
          disabled: !this.trapFocus,
          active: this.show,
          onEsc: this.onEsc,
          autoFocus: this.autoFocus
        }, {
          default: () => {
            var m;
            return c(x, {
              name: "fade-in-scale-up-transition",
              appear: (m = this.appear) !== null && m !== void 0 ? m : this.isMounted,
              onEnter: n,
              onAfterEnter: this.onAfterEnter,
              onAfterLeave: l,
              onBeforeLeave: d
            }, {
              default: () => {
                const p = [[T, this.show]], {
                  onClickoutside: h
                } = this;
                return h && p.push([U, this.onClickoutside, void 0, {
                  capture: !0
                }]), k(this.preset === "confirm" || this.preset === "dialog" ? c(D, Object.assign({}, this.$attrs, {
                  class: [`${r}-modal`, this.$attrs.class],
                  ref: "bodyRef",
                  theme: this.mergedTheme.peers.Dialog,
                  themeOverrides: this.mergedTheme.peerOverrides.Dialog
                }, R(this.$props, q), {
                  "aria-modal": "true"
                }), t) : this.preset === "card" ? c(K, Object.assign({}, this.$attrs, {
                  ref: "bodyRef",
                  class: [`${r}-modal`, this.$attrs.class],
                  theme: this.mergedTheme.peers.Card,
                  themeOverrides: this.mergedTheme.peerOverrides.Card
                }, R(this.$props, I), {
                  "aria-modal": "true",
                  role: "dialog"
                }), t) : this.childNodeRef = i, p);
              }
            });
          }
        })];
      }
    })), [[T, this.displayDirective === "if" || this.displayed || this.show]]) : null;
  }
});
export {
  pe as default
};
